"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Networking = void 0;
const cross_fetch_1 = require("cross-fetch");
const CodedError_1 = require("./CodedError");
class Networking {
    constructor(baseUri) {
        this.baseUri = baseUri;
    }
    throwOnError(res) {
        if (res.err_no) {
            throw new CodedError_1.CodedError(res.err_msg, res.err_no);
        }
        else {
            return res.data;
        }
    }
    get(path) {
        return (0, cross_fetch_1.fetch)(this.baseUri + '/' + path, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(res => res.json()).then(this.throwOnError);
    }
    post(path, body) {
        return (0, cross_fetch_1.fetch)(this.baseUri + '/' + path, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body)
        }).then(res => res.json()).then(this.throwOnError);
    }
}
exports.Networking = Networking;
//# sourceMappingURL=Networking.js.map